import React from 'react';
import './AboutUs.css';

import { Banner, PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Sponsors, PortfolioSection } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About section */}
        <Counter /> {/* Stats section */}
        <Services /> {/* Services Slider */}
        <Banner /> {/* Banner Component */}
        <Team /> {/* Team section */}
        <Testimonials /> {/* Client reviews */}
        <PortfolioSection /> {/* Portfolio Section */}
        <Sponsors /> {/* Sponsors Slider */}

      </section>

    </>
  );
}

export default AboutUs;